import graphql__76146756740e32aa984e from "./__generated__/ParticipativeModuleResultsFormFieldStackedAbsolute_result.graphql.js";import { graphql, useFragment } from "react-relay";

import Chart from "./Chart";
import ParticipativeModuleResultsFormFieldContainer from "./ParticipativeModuleResultsFormFieldContainer";
import { stackedAbsoluteChartConfig } from "../../lib/charts/stackedAbsoluteChart";
import { useChartOptions } from "../../lib/charts/useChartColors";

const ParticipativeModuleResultsFormFieldStackedAbsolute = props => {
  const result = useFragment(
    ParticipativeModuleResultsFormFieldStackedAbsolute_result,
    props.result
  );

  const { allowDisplayingPatternFill, chartLabel: label, colors } = result;

  const chartOptions = useChartOptions(colors);

  const chartConfig = {
    ...stackedAbsoluteChartConfig(result, { label }),
    ...chartOptions
  };

  return (
    <ParticipativeModuleResultsFormFieldContainer {...props} result={result}>
      <Chart
        allowDisplayingPatternFill={allowDisplayingPatternFill}
        chartOptions={chartConfig}
      />
    </ParticipativeModuleResultsFormFieldContainer>
  );
};

const ParticipativeModuleResultsFormFieldStackedAbsolute_result = graphql__76146756740e32aa984e;

export default ParticipativeModuleResultsFormFieldStackedAbsolute;
